.aw{flex-shrink:0;}